import { paymentQueryUrl } from 'syf-api/api/endpoints';
import useFetch from 'syf-api/api/useFetch';
export var paymentQueryCacheKey = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, page = _a.page, paymentId = _a.paymentId, size = _a.size;
    return [
        paymentQueryUrl,
        { accountId: accountId, accountIdType: accountIdType, page: page, size: size, paymentId: paymentId }
    ];
};
export var cancelPaymentQuery = function (_a) {
    var accountId = _a.accountId, accountIdType = _a.accountIdType, config = _a.config, paymentId = _a.paymentId;
    return function () {
        var fetchWrapper = useFetch(config);
        var params = new URLSearchParams({
            'cipher.accountId': accountId
        });
        if (accountIdType) {
            params.set('accountIdType', accountIdType);
        }
        return fetchWrapper("".concat(paymentQueryUrl, "/").concat(paymentId, "?").concat(params), {
            method: 'DELETE',
            headers: {
                'Content-Type': '',
                Accept: ''
            }
        });
    };
};
//# sourceMappingURL=cancel-payment-query.js.map